// extracted by mini-css-extract-plugin
export default {"content":"GaOElxbaZm"};